/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalId = "/custom_objects/:type_name/:external_id" as const;

/** Keep in sync with customObjectsTypeName — literal avoids circular import with that module. */
export const customObjectsTypeNameExternalIdCacheKeys = ["/custom_objects/:type_name"] as const;
